import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {useHistory} from 'react-router-dom';
import Label1 from './common/Label1';
import LinkTableCellComponent from './common/LinkTableCellComponent';
import {getDurationInMonth} from '../utils';
import {currencyFormatter} from '../utils/formatter';
import {groupAndSortItemsByFieldName} from '../utils/customersUtils';
import {pathName} from '../const/paths';
import {profileSections} from '../pages/CustomerProfile';

const Wrapper = styled.div`
  
`;

const SelectedCustomersWrapper = styled.div`
    margin: 40px 44px;
    
    /* text-xl/Medium */
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    /* identical to box height, or 100% */
    
    /* default/blue/600 */
    color: var(--color-blue-600);
`;

const ContractInfoSection = styled.div`
     display: flex;
     width: 100%;
`;

const ContractInfo = styled.div`
    overflow-x: scroll;
    padding: 32px 44px;

    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 45px;
    grid-template-columns: repeat(7, max-content);
    
    ::-webkit-scrollbar {
      display: none;
    }
    
    
    > div {
      display: grid;
      grid-row-gap: 20px;
      grid-auto-flow: row;
      padding-right: 15px;
    }
`;

function ContractsSignPanelHeading({contracts}) {
    const history = useHistory();
    const multipleContracts = contracts.length > 1;

    const selectedContract = contracts[0] || {};

    const getBatchContractHeading = contracts => {
        let headings = '';

        // group contracts by company name
        const contractGroups = groupAndSortItemsByFieldName(contracts, 'companyName');

        const companies = Object.keys(contractGroups);

        for (let i = 0; i < companies.length; i++) {
            if (i > 4) {
                const amountRemaining = companies.length - 5;
                headings = `${headings} + ${amountRemaining} More`;
                break;
            }

            headings = `${headings} ${companies[i]}`;

            const moreItems = (companies.length - 1) > i;
            if (moreItems) headings += ',';
        }

        return headings;
    };

    const batchContractHeading = getBatchContractHeading(contracts);

    const handleOnContractIdClick = contract => {

    };

    const onCompanyClick = (contract) => {
        const {companyId, customerId} = contract;
        history.push(pathName.customersProfilePage(companyId, customerId), {section: profileSections.Identity});
    };

    return (
        <>
            {
                !multipleContracts &&
                <div style={{paddingLeft: 44}}>
                    <LinkTableCellComponent
                        onLinkClick={() => onCompanyClick(contracts[0])}
                        name={`${contracts[0]?.companyName}'s Profile`}
                    />
                </div>
            }

            {
                multipleContracts ? (
                    <SelectedCustomersWrapper>
                        {batchContractHeading}
                    </SelectedCustomersWrapper>
                ) : (
                    <ContractInfoSection>
                        <ContractInfo>
                            <div>
                                <Label1>
                                    Contract
                                </Label1>

                                <LinkTableCellComponent
                                    name={selectedContract.contractNumber}
                                    onLinkClick={
                                        () => handleOnContractIdClick(selectedContract)
                                    }
                                />
                            </div>

                            <div>
                                <Label1>
                                    Plan Duration
                                </Label1>

                                <div>
                                    {getDurationInMonth(selectedContract.startDateOfContract, selectedContract.endDateOFContract)}
                                </div>
                            </div>

                            <div>
                                <Label1>
                                    Monthly Payment
                                </Label1>

                                <div>
                                    $ {currencyFormatter(selectedContract.monthlyPayment)}
                                </div>
                            </div>

                            <div>
                                <Label1>
                                    Total Cash Price
                                </Label1>

                                <div>
                                    $ {currencyFormatter(selectedContract.totalCashPrice)}
                                </div>
                            </div>
                        </ContractInfo>
                    </ContractInfoSection>
                )}
        </>
    );
}

ContractsSignPanelHeading.propTypes = {contracts: PropTypes.array.isRequired};
ContractsSignPanelHeading.defaultProps = {contracts: []};

export default ContractsSignPanelHeading;
